import CancelablePromise from 'mn-utils/CancelablePromise';
import {TFilter, TList} from '@/types';
import {get, post} from '../../http';
import {TListItem} from './types';
import {getTransactionDetails, getTransactionsList} from './mock';

export function apiAdminTransactionsList(params: TFilter<TListItem>): Promise<TList<TListItem>> {
  const url = '/f2c/v1/admin/transactions';
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;

  if (process.env.MOCK) {
    const response = {
      list: getTransactionsList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return get(url, params);
}

export function apiAdminTransactionGet(params: {id: string}): Promise<TList<TListItem>> {
  const url = '/f2c/v1/admin/payment/' + params.id;

  if (process.env.MOCK) {
    const response = getTransactionDetails();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return get(url);
}
export function apiAdminPaymentsList(params: TFilter<TListItem>): Promise<TList<TListItem>> {
  const url = '/f2c/v1/admin/payments';

  if (process.env.MOCK) {
    const response = getTransactionDetails();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return get(url, params);
}
export function apiAdminNuveiReconciliationList(params): Promise<TList<TListItem>> {
  const url = '/f2c/v1/admin/reconciliation/nuvei/list';

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    return CancelablePromise.delay(500, response);
  }

  return get(url, params);
}
export function apiAdminNuveiReconciliationStart(params): Promise<TList<TListItem>> {
  const url = '/f2c/v1/admin/reconciliation/nuvei/start';

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}
export function apiAdminPaymentsNuveiStatusUpdate(params): Promise<TList<TListItem>> {
  const url = '/f2c/v1/admin/reconciliation/nuvei/apply';

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

export function apiAdminLiquidpoolFailedListGit(): Promise<TList<TListItem>> {
  const url = '/f2c/v1/admin/withdrawal-flows/liqpool/list-failed';

  if (process.env.MOCK) {
    const response = getTransactionDetails();
    return CancelablePromise.delay(500, response);
  }

  return get(url);
}

export function apiAdminTrxReset({id}): Promise<TList<TListItem>> {
  const url = `/f2c/v1/admin/withdrawal-flows/liqpool/retry/${id}`;

  if (process.env.MOCK) {
    const response = getTransactionDetails();
    return CancelablePromise.delay(500, response);
  }

  return post(url);
}

// Send a callback for transaction
export function apiAdminTrxChargeback(params): Promise<TListItem> {
  const url = '/f2c/v1/admin/chargebacks';
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    return CancelablePromise.delay(500, response);
  }
  return post(url, params);
}

// Send a callback for transaction
export function apiAdminTrxChargebackGet({id}): Promise<TListItem> {
  const url = '/f2c/v1/admin/chargeback/' + id;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    return CancelablePromise.delay(500, response);
  }
  return get(url);
}
